module.exports = "<p>\n  public-detail works!\n</p>\n"